import React from 'react';
import { ArcDroneMarker, ArcPolyline, DestinationMarker, TakeOffMarker } from '@src/core/controllers';
import {
  arcHistoryDestinationPoint,
  arcHistoryDroneHomeLeg,
  arcHistoryDronePoint,
  arcHistoryOrderPath,
  arcHistoryTakeoffPoint,
} from '@src/core/extensions';
import DroneHomePath from '@src/features/order/pages/upsert-mission-page/components/drone-home-path';
import { RouteWaypointNumbers } from '@src/features/order/pages/upsert-mission-page/components';
import { OrderMissionEntity } from '@src/features/order/entities';

type OrderRouteLayerProps = {
  order: OrderMissionEntity;
  droneVariant: 'idleGray' | 'error';
};

// Terminal-order route layer shared by history and the orders-page status popups so both render
// identically: drone HOME -> takeoff leg, the full route, takeoff/destination pins, the (gray/error)
// drone at HOME, and numbered labels on the intermediate waypoints.
const OrderRouteLayer: React.FC<OrderRouteLayerProps> = ({ order, droneVariant }) => {
  const homeLeg = arcHistoryDroneHomeLeg(order);
  const takeoffPos = arcHistoryTakeoffPoint(order);
  const destinationPos = arcHistoryDestinationPoint(order);
  const dronePos = arcHistoryDronePoint(order);

  const DroneMarker = droneVariant === 'error' ? ArcDroneMarker.error : ArcDroneMarker.idleGray;

  return (
    <React.Fragment>
      {homeLeg && <DroneHomePath from={homeLeg.from} to={homeLeg.to} />}
      <ArcPolyline.default path={arcHistoryOrderPath(order)} />

      {takeoffPos && <TakeOffMarker.confirmed position={takeoffPos} />}
      {destinationPos && <DestinationMarker.confirmed position={destinationPos} />}
      {dronePos && <DroneMarker position={dronePos} />}

      <RouteWaypointNumbers
        waypoints={order.waypoints}
        takeoff={takeoffPos}
        destination={destinationPos}
      />
    </React.Fragment>
  );
};

export default OrderRouteLayer;
